import { clearDefaultSessionTokenHeader } from "../../componentes-padrao/AxiosConfig";
import { api, api_go } from "../../modules/Axios/api";
import { EmpesaLogadaPayload } from "./types";

export const login = async (code: string, redirectUri: string) => {
    return await api.post("auth/login", {
        code: code,
        redirect_uri: redirectUri,
    });
};

export const setEmpresa = async (payload: EmpesaLogadaPayload) => {
    return await api.post("auth/set-selected-company", {
        company_id: payload.empresaID,
        branch_ids: payload.filialIDs,
    });
};

export const setEmbarcadora = async (payload: {
    embarcadoraID: number;
    filialIDs: number[];
}) => {
    return await api_go.post("auth/set-selected-shipper", {
        shipper_id: payload.embarcadoraID,
        branch_ids: payload.filialIDs,
    });
};

export const refreshToken = async (refreshToken: string) => {
    const { data } = await api.post("auth/refresh", {
        refresh_token: refreshToken,
    });
    return data;
};

export const logout = async (refreshToken: string) => {
    const { data } = await api.post("auth/logout", {
        refresh_token: refreshToken,
    });

    clearDefaultSessionTokenHeader();
    return data;
};

export const getCompaniesAllowed = async () => {
    const { data } = await api.get("auth/companies-allowed");

    return data;
};

export const getBranchesAllowed = async (selectedCompanyId: number) => {
    const { data } = await api.get("auth/branches-allowed", {
        params: {
            company_id: selectedCompanyId,
        },
    });

    return data;
};

export const getAllowedMenus = async () => {
    const { data } = await api.get("auth/menus-allowed");

    return data;
};

export const getAllowedMenusForShipper = async () => {
    const { data } = await api_go.get("auth/menus-allowed");

    return data;
};

export const getScreenAllowedActions = async (screenGridClass: string) => {
    const { data } = await api.get("auth/screen-allowed-actions", {
        params: {
            screen_grid_class: screenGridClass,
        },
    });

    return data;
};

export const getShippersAllowed = async () => {
    const { data } = await api_go.get("auth/shippers-allowed");

    return data;
};

export const getBranchesAllowedForShipper = async (shipperId: number) => {
    const { data } = await api_go.get(`auth/branches-allowed/${shipperId}`);

    return data;
};

export const getCarriersAllowed = async () => {
    const { data } = await api_go.get("auth/carriers-allowed");

    return data;
};

export const setTransportador = async (payload: { transportadorID: number }) => {
    return await api_go.post("auth/set-selected-carrier", {
        carrier_id: payload.transportadorID,
    });
};
